import { Component, OnInit, ViewChild } from '@angular/core';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { env } from 'process';
import { environment } from '../../../environments/environment';
@Component({
  selector: 'completed',
  templateUrl: './completed.component.html',
  styleUrls: ['./completed.component.css']
})
export class CompletedComponent implements OnInit {
  public url: any
  public height = 500;
  @ViewChild('header') targetElement: any;
  constructor(private domSanitizer: DomSanitizer) { }
  transform(url) {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
  }
  ngOnInit(): void {
    let header = document.getElementById('header');
    let menuHeader = document.getElementById('menu-header');
    this.height = window.innerHeight - (menuHeader.clientHeight + header.clientHeight) - 110;
    this.url = this.transform(environment.surveyLink);
    //let visualize=this.transform(environment.visualize.Kitchen)
  }
}
